<script setup lang="ts">
import type { ProductDetail } from '~/types/api'

const props = defineProps<{
  product: ProductDetail
  productLineTitle: string | undefined
}>()

const userStore = useUser()
const { showPrices } = storeToRefs(userStore)

const requestModalOpen = ref(false)

const scrollY = ref(0)

function openModal() {
  requestModalOpen.value = true
  scrollY.value = window.scrollY
  document.body.classList.add('overflow-hidden', 'fixed')
  document.getElementsByTagName('html')[0].classList.add('!overflow-auto')
  document.body.style.top = `-${scrollY.value}px`
}

function closeModal() {
  requestModalOpen.value = false
  document.body.classList.remove('overflow-hidden', 'fixed')
  document.body.style.top = ''
  document.getElementsByTagName('html')[0].classList.remove('!overflow-auto')
  window.scrollTo(0, scrollY.value)
}

const count = ref(1)
</script>

<template>
  <div>
    <UiButtonBlack @click="openModal()">
      {{ $t('configurator.request') }}
    </UiButtonBlack>
    <div
      v-if="requestModalOpen"
      class="fixed left-0 top-0 z-50 h-full w-full overflow-auto bg-black bg-opacity-75 backdrop-blur-md"
      @click="closeModal()"
    >
      <div
        class="container relative my-10 overflow-hidden selection:!bg-black selection:!text-white"
      >
        <div class="relative bg-white" @click.stop>
          <button class="absolute right-12 top-12 z-10" @click="closeModal()">
            {{ $t('base.close') }}
          </button>
          <div class="grid gap-5 lg:grid-cols-2">
            <div class="border-neutral-200 py-12 lg:border-r-4">
              <div class="mb-4 px-12">
                <p class="font-pragmatica-ext text-4xl font-bold">
                  {{ props.productLineTitle }}
                </p>
                <p class="font-pragmatica-ext text-2xl font-bold">
                  {{ props.product.title }}
                </p>
              </div>
              <ul
                class="list-disc border-b-4 border-neutral-200 pb-12 pl-16 pr-12"
              >
                <li
                  v-for="descriptionItem in props.product.descriptionItems"
                  :key="descriptionItem.nid"
                >
                  {{ descriptionItem.title }}
                </li>
              </ul>
              <ProductOrderCountAndPrice
                v-model="count"
                class="border-b-4 border-neutral-200 p-12"
                :price="props.product.minimalPrice || 0"
                :show-prices="showPrices"
                :currency="props.product.currency"
              />
              <div class="p-3 md:p-5 lg:p-10">
                <ProductOrderForm
                  :product-title="`${props.productLineTitle} ${props.product.title}`"
                  :quantity="count"
                  :product-id="props.product.nid"
                  @close="closeModal"
                />
              </div>
            </div>
            <div
              v-if="props.product.images[0]?.url"
              class="relative p-12 max-lg:row-start-1"
            >
              <NuxtImg
                :src="withHost(props.product.images[0]?.url)"
                sizes="400px sm:50vw"
                class="mx-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
